import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';

import { Text } from '@nerdwallet/currency';

import CsrBoxLogoTile from './csr-box-logo-tile';

import styles from './csrBoxLogo.module.less';

const CsrBoxLogo = ({ title, tiles }) => {
  const renderedTiles = _.map(tiles, (tile, id) => (
    <CsrBoxLogoTile {...tile} key={id} />
  ));

  return (
    <div className={styles.csrBoxLogoContainer}>
      <div className={styles.csrBoxLogoTitle}>
        <Text bold>{title}</Text>
      </div>
      <div className={styles.csrBoxLogo}>{renderedTiles}</div>
    </div>
  );
};

CsrBoxLogo.displayName = 'CSR Box Logo';

CsrBoxLogo.propTypes = {
  title: PropTypes.string,
  tiles: PropTypes.arrayOf(PropTypes.shape(CsrBoxLogo.propTypes)),
  className: PropTypes.string,
  id: PropTypes.number,
};

export default CsrBoxLogo;
